import './team.sass'
import AtheneumOfficeList from './AtheneumOfficeList'
import Button from '@components/Button'
import DocumentTitle from 'react-document-title'
import FilterGroup from '@components/FilterGroup'
import ListEmployees from './Components/ListEmployees'
import ListTeam from './Components/ListTeam'
import MonthYearPicker from '@components/MonthPicker/MonthYearPicker'
import React, { Component } from 'react'
import Scroll from '@components/Scroll'
import Spinner from '@components/spinner'
import TeamStore from '@stores/Team.store'
import _ from 'lodash'
import moment from 'moment'
import propTypes from 'prop-types'
import { SearchPanelContainer } from '@components/Search'
import { downloadFromUrl, exportDialogMessage, tokenStorage } from '@atheneum/api/dist/lib'
import { observer, inject } from 'mobx-react'
import { showDialog } from '@components/Dialog'

class Team extends Component {
	static propTypes = {
		modalStore: propTypes.object.isRequired,
		staticData: propTypes.object.isRequired,
		growlStore: propTypes.object.isRequired,
		queueProcessorStore: propTypes.object.isRequired
	}

	constructor(props) {
		super(props)
		this.store = new TeamStore(props.staticData, props.growlStore)
		this.store.init().then(() => {
			const teamName = window.location.href.split('#')[1]
			this.store.scrollToTeamName(teamName)
		})
	}

	componentDidUpdate() {
		this.store.scrollToPosition()
	}

	exportTeams = async () => {
		const { queueProcessorStore, growlStore } = this.props
		const jobId = await this.store.export()
		const filename = `teamsDownload.xlsx`

		queueProcessorStore.trackJob(
			jobId,
			({ url }) => {
				downloadFromUrl({ url: `${url}?token=${tokenStorage.get()}`, filename })
			},
			err => {
				growlStore.showError(err.message || 'Error creating export')
			}
		)

		await exportDialogMessage({ exportType: 'teams' })
	}

	newTeam = () => {
		this.props.modalStore.show({
			type: 'TEAM_MODAL',
			props: {
				teamStore: this.store,
				employees: this.store.getAccountManagerOrPrincipal(),
				principals: this.store.getPrincipals(),
				save: this.store.createTeam,
				monthYear: this.store.monthYear
			}
		})
	}

	editTeam = team => {
		let employees = this.store.getAccountManagerOrPrincipal()
		if (team.accountManager) {
			employees.push(team.accountManager)
		}

		if (team.seniorAccountManager) {
			employees.push(team.seniorAccountManager)
		}

		this.props.modalStore.show({
			type: 'TEAM_MODAL',
			props: {
				teamStore: this.store,
				employees: employees,
				principals: this.store.getPrincipals(),
				save: this.store.updateTeam,
				teamId: team.id,
				initialValues: {
					team: {
						name: team.name,
						atheneumOfficeId: team.atheneumOfficeId,
						isExpertBackedResearch: !!team.teamIsExpertBackedResearch,
						outlookTeamUserId: team.outlookTeamUserId
					},
					principalId: team.accountManager && team.accountManager.principalId,
					seniorPrincipalId:
						team.accountManager && team.accountManager.seniorPrincipalId,
					accountManagerId: team.accountManager && team.accountManager.id,
					seniorAccountManagerId: team.seniorAccountManager && team.seniorAccountManager.id
				},
				edit: true,
				monthYear: this.store.monthYear
			}
		})
	}

	removeTeam = teamId => {
		showDialog({
			title: 'Remove team',
			text: 'Are you sure you want to remove whole team and unassign all employees?',
			showCancelButton: true
		})
			.then(() => {
				this.store.position = null
				this.store.removeTeam({ teamId })
			})
			.catch(() => false)
	}

	removeEmployee = (employeeId, teamId) => {
		showDialog({
			title: 'Remove employee',
			text: 'Removing employee from team will remove all employees under them as well',
			showCancelButton: true
		})
			.then(() => {
				this.store.scrollToTeamId(teamId)
				this.store.removeEmployee({ employeeId })
			})
			.catch(() => false)
	}

	addEmployee = (teamId, supervisorId, teamLeader, canBeSenior) => {
		this.store.scrollToTeamId(teamId)
		this.props.modalStore.show({
			type: 'ADD_EMPLOYEE_MODAL',
			props: {
				employees: teamLeader
					? this.store.getTeamLeaders()
					: this.store.getAssociates(),
				teamId,
				supervisorId,
				assignEmployee: this.store.assignEmployee,
				canBeSenior
			}
		})
	}

	render() {
		const { EMPLOYEE_POSITIONS } = this.props.staticData.CONST
		const amPositions = [
			EMPLOYEE_POSITIONS.ACCOUNT_MANAGER,
			EMPLOYEE_POSITIONS.PRINCIPAL
		]
		let accountManagers = this.store.employees.filter(
			e => amPositions.includes(e.positionId) && e.teamId
		)
		let teams = this.store.teams.map(team => {
			return {
				...team,
				accountManager: accountManagers.find(
					manager => manager.teamId === team.id && !manager.isSenior
				),
				seniorAccountManager: accountManagers.find(
					manager => manager.teamId === team.id && manager.isSenior
				)
			}
		})

		accountManagers = _.sortBy(accountManagers, [
			'atheneumOfficeName',
			'accountManagerName',
			'teamName'
		])

		return (
			<DocumentTitle title="Teams management | Atheneum Partners">
				<div className="team--page-container">
					<TeamsPanel
						accountManagers={accountManagers}
						newTeam={this.newTeam}
						store={this.store}
						exportTeams={this.exportTeams}
					/>
					<div className="team-page-container-inner">
						<Scroll isVisible>
							<div className="expert-wrapper">
								<div>
									{this.store.loading ? (
										<Spinner />
									) : (
										<div className="">
											<div className="team--teams-container">
												{teams.map(team => (
													<ListTeam
														key={team.id}
														team={team}
														accountManager={team.accountManager}
														growlStore={this.props.growlStore}
														store={this.store}
														addEmployee={this.addEmployee}
														editTeam={this.editTeam}
														removeEmployee={this.removeEmployee}
														removeTeam={this.removeTeam}
													/>
												))}
											</div>

											<div
												className="team--unassigned-employees"
												id="unassigned-employees">
												<h2>
													Unassigned Employees (
													{this.store.getUnassigned().length})
												</h2>
												<div>
													<ListEmployees
														store={this.store}
														employees={this.store.getUnassigned()}
													/>
												</div>
											</div>
										</div>
									)}
								</div>
							</div>
						</Scroll>
					</div>
				</div>
			</DocumentTitle>
		)
	}
}

const TeamsPanel = ({ accountManagers, newTeam, exportTeams, store }) => {
	const quickHistoryDates = [
		moment().subtract(1, 'month'),
		moment().subtract(2, 'month'),
		moment().subtract(3, 'month')
	]

	return (
		<SearchPanelContainer searchTitle="Teams">
			{store.isEditable ? (
				<Button
					onClick={newTeam}
					className="team-btn button button--primary button--full">
					New team
				</Button>
			) : (
				''
			)}
			<Button
				onClick={exportTeams}
				className="team-btn button button--primary button--full">
				Export
			</Button>
			<FilterGroup label="Select month">
				<MonthYearPicker
					monthAndYear={store.monthYear}
					onChange={store.changeMonthYear}
				/>
			</FilterGroup>
			<div className="team--teams-panel--quick-history">
				{quickHistoryDates.map(date => (
					<div
						key={date}
						className="link"
						onClick={() => store.changeMonthYear(date)}>
						{date.format('MMM YYYY')}
					</div>
				))}
			</div>
			{accountManagers.length ? <AtheneumOfficeList teamStore={store} /> : ''}
		</SearchPanelContainer>
	)
}

TeamsPanel.propTypes = {
	store: propTypes.object.isRequired,
	accountManagers: propTypes.array.isRequired,
	newTeam: propTypes.func.isRequired,
	exportTeams: propTypes.func.isRequired
}

export default inject(
	'modalStore',
	'staticData',
	'queueProcessorStore',
	'growlStore'
)(observer(Team))
